import React from "react";
import { Popover, OverlayTrigger, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const OverLay = ({ user, logOut }) => {
  const popover = (
    <Popover id="popover-basic">
      <Popover.Title>{user === "Admin" ? "Admin" : "Merchant"}</Popover.Title>
      <Popover.Content>
        <Link
          to={user === "Admin" ? "/admin/dashboard" : "/dashboard"}
          className="py-2 text-decoration-none d-block px-2 text-grey"
        >
          {user === "Admin" ? "Dashboard" : "My Business"}
        </Link>
        <Link
          to="/"
          className="py-2 cursor text-decoration-none px-2 d-block text-grey"
          onClick={logOut}
        >
          Log Out
        </Link>
      </Popover.Content>
    </Popover>
  );
  return (
    <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
      <Button variant="outline-light user-btn" className="border-0">
        <i className="fal fa-user-circle pr-1"></i>
        {user}
      </Button>
    </OverlayTrigger>
  );
};

export default OverLay;
